
/**
 *  why this functions ( findGoodSplitNumber ,wrapText ) :
 *  for this use case, tooltip label will split the string based on spaces,in case name without spaces tooltip will take the width of the string and UI will break,
 * we take the string and find the good number in order if we split the string based on it and add spaces tooltip label will look like text wraps.
 */
export const findGoodSplitNumber = (name: string, maxPartLength = 60, minPartLength = 40) => {
    const maxParts = Math.ceil(name.length / minPartLength);
    const minParts = Math.floor(name.length / maxPartLength);

    let idealParts = minParts;
    let smallestRemainder = name.length % minParts;
    let idealPartLength = Math.floor(name.length / minParts);

    for (let i = minParts + 1; i <= maxParts; i++) {
        let currentRemainder = name.length % i;
        if (currentRemainder < smallestRemainder) {
            smallestRemainder = currentRemainder;
            idealParts = i;
            idealPartLength = Math.floor(name.length / i);
        }
    }

    return { idealParts, idealPartLength };
}

export const wrapText = (name: string) => {
    if (!name) return name;

    const { idealParts, idealPartLength } = findGoodSplitNumber(name);
    let result = '';
    let index = 0;

    while (index < name.length) {
        let nextIndex = index + idealPartLength > name.length ? name.length : index + idealPartLength;
        result += name.slice(index, nextIndex) + (nextIndex < name.length ? ' ' : '');
        index = nextIndex;
    }

    return result;
}

export const displayName = (name: string, maxLength = 60) => {
    if (!name) return name;
    const shouldTruncate = name.length > maxLength
    const displayName = shouldTruncate ? `${name.substring(0, maxLength - 3)}...` : name
    return displayName
}
